'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './document-tree-add-from-archive.routes';

export class DocumentTreeAddFromArchiveComponent {
  /*@ngInject*/
  constructor(Upload, Auth, DocumentService, $state, $stateParams, Config, $uibModal, dialogs) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Upload = Upload;
    this.Auth = Auth;
    this.DocumentService = DocumentService;
    this.type = $stateParams.type;
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;

    this.allowedMimeTypes = Config.getPlatformConfig().getAllowedContentTypesForUpload().join(',');

    var documentConfig = Config.getModuleConfig(Config.Modules.Document);

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Document From Archive");

    this.permissionModel = {};
    this.roles = Config.getPlatformConfig().getPermissionRoles();
    this.defaultUploadUserPermission = Config.getPlatformConfig().getDefaultPermissionUserUpload();
    this.roles.forEach(role => {
      this.permissionModel[role] = this.defaultUploadUserPermission.includes(role);
    });

    this.documentTree = documentConfig.getDocumentTree();

    // Enumeration with possible document types
    this.documentType = documentConfig.getTypes();
    this.documentPageCategories = documentConfig.getPageCategories();

    this.documentType = [];
    this.docTypesEnum = [];

    this.addPath = _ => {
      this.document.tree.push({
        path: "",
        orderNumber: 100
      });
    };

    let rFn = (node, o, parent) => {

      let _parentId = (parent) ? parent.value + "::" : "";
      let _parentName = (parent) ? parent.name + " → " : "";

      let newNode = {
        value: _parentId + node.id,
        name: _parentName + node.name,
        group: "General"
      };

      o.push(newNode);

      if (node.children && node.children.length) {
        node.children.forEach(child => rFn(child, o, newNode))
      }
    };

    this.documentTree.forEach(node => rFn(node, this.docTypesEnum));

    this.documentTemplate = {
      tree: [{
        path: '',
        orderNumber: 100
      }],
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.document = angular.copy(this.documentTemplate);
    this.submitted = false;
  }

  removeCat(idx) {
    this.document.tree.splice(idx,1);
  }

  openAssetBrowserModal(section) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToFileTypes: ["application/pdf"]
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (selectedFiles) {
        that.file = selectedFiles[0];
        that.file.permission.forEach(perm => that.permissionModel[perm] = true);
      },
      function () { /* cancel */ }
    );

  }


  upload(form) {

    this.submitted = true;
    this.sendSuccess = false;
    this.sendFailure = false;

    if (form.$valid) {

      if (!this.file || !this.file._id) {
        this.dialogs.notify("No File Selected", "Please select a file");
        return;
      }

      this.document.document = this.file._id;

      this.DocumentService.save(this.document, () => {
          this.document = angular.copy(this.documentTemplate);
          this.submitted = false;
          this.sendSuccess = true;
        },
        (err) => {
          this.sendFailure = true;
        })

    }

  }

}

export default angular.module('conduuApp.documentTreeAddFromArchive', [uiRouter])
  .config(routes)
  .component('documentTreeAddFromArchive', {
    template: require('./document-tree-add-from-archive.html'),
    controller: DocumentTreeAddFromArchiveComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document/tree-add-from-archive/document-tree-add-from-archive.component.js